import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { defineMessages, FormattedMessage } from 'react-intl';

// ui
import {
  Avatar,
  Button,
  CardHeader,
  Icon,
  IconButton,
  Tooltip,
} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import QuestionIcon from '@material-ui/icons/HelpOutline';
import {
  chartTypes,
  messages as chartTypeMsgs,
} from '../../chart-controls/chart-type-select/ChartTypeSelect';
import * as actions from '../../../../state';
import styles from '../styles.module.css';

// components
import ChartCardMenu from './ChartCardMenu';

const messages = defineMessages({
  CHOOSE_TYPE: {
    id: 'CHOOSE_TYPE',
    defaultMessage: 'Choose Type',
  },
  DELETE_CARD_TOOLTIP: {
    id: 'DELETE_CARD_TOOLTIP',
    defaultMessage: 'Delete this card',
  },
});

function ChartCardPlaceholder({
  chart,
  deleteChart,
  editChart,
}) {
  const dispatch = useDispatch();
  const layout = useSelector(actions.selectLayout);

  const selectChart = () => {
    dispatch(actions.selectedChartId(chart.id));
    dispatch(actions.showRightSidebar(true));

    /* attempt to scroll content container to top */
    setTimeout(() => { // put in a timeout so a render cycle can complete first
      try { // catch here because sometimes gridElement isn't found
        const gridElement = document.getElementById('content-container');
        gridElement.scrollTo(0, 0);
      } catch (e) {
        // i dont care do u
      }
    }, 1);
  };

  const editingCardPlaceholder = () => (
    <>
      <Avatar style={{ margin: 'auto', width: 64, height: 64 }}>
        <QuestionIcon />
      </Avatar>

      <div className={styles.chooseTypeMsg}>
        <FormattedMessage {...messages.CHOOSE_TYPE} />
      </div>
    </>
  );

  const placingCardPlaceholder = () => (
    <>
      <Button
        variant="contained"
        color="primary"
        onClick={selectChart}
        className={styles.mainBtns}
      >
        <FormattedMessage {...messages.CHOOSE_TYPE} />
      </Button>

      <Tooltip disableFocusListener title={<FormattedMessage {...messages.DELETE_CARD_TOOLTIP} />}>
        <IconButton className={styles.inlineDeleteBtn} onClick={deleteChart}>
          <DeleteIcon />
        </IconButton>
      </Tooltip>
    </>
  );

  const newCardIcon = () => {
    const selectedChartType = chart.type;

    let typeDef = {};
    chartTypes.forEach((typeGroup) => typeGroup.types.forEach((chartType) => {
      if (chartType.type === selectedChartType) { typeDef = chartType; }
    }));

    const selectedChartTypeMsg = <FormattedMessage {...chartTypeMsgs[typeDef.labelId]} />;

    return (
      <>
        {!layout.publicMode && !layout.editMode && !layout.viewOnly
            && (
            <CardHeader
              key={chart.id}
              action={(
                <ChartCardMenu
                  allowCopy={false}
                  chart={chart}
                  editChart={editChart}
                  deleteChart={deleteChart}
                />
              )}
              classes={{ action: styles.cardActions }}
            />
            )}

        { typeDef.icon
            && (
            <Icon
              className={styles.newcardIcon}
              style={{ backgroundColor: typeDef.color }}
            >
              <span>{typeDef.icon}</span>
            </Icon>
            )}

        { typeDef.nsIcon
            && (
            <Icon
              className={styles.newcardIcon}
              style={{ backgroundColor: typeDef.color, top: '8px !important' }}
            >
              <span className={`nsicon-m ${typeDef.nsIcon}`} />
            </Icon>
            )}

        <p style={{ color: 'rgba(0,0,0,0.56)' }}>
          {selectedChartTypeMsg}
        </p>
      </>
    );
  };

  return (
    <div className={`animate__animated animate__fadeIn ${styles.cardPlaceholder}`}>
      <div className={styles.placeholderContainer}>
        {(chart.type === 'new'
            && layout.showRightSidebar
            && editingCardPlaceholder())
          || (chart.type === 'new' && placingCardPlaceholder())
          || newCardIcon(chart.type)}
      </div>
    </div>
  );
}

ChartCardPlaceholder.defaultProps = {
  chart: null,
  deleteChart: () => {},
  editChart: () => {},
};

ChartCardPlaceholder.propTypes = {
  chart: PropTypes.shape({}),
  deleteChart: PropTypes.func,
  editChart: PropTypes.func,
};

export default ChartCardPlaceholder;
